import { Div, TableBuilder, Text, CollectionView, RefNumber } from "@tblabs/truffle";
import { Order } from "../../../../../Models/Order";
import { OrdersManager } from "../../../../../Services/Storage/OrdersManager";
import { Router } from "../../../../../Services/Router";
import { BasketList } from "./Components/BasketList";
import { OrderHeader } from "./Components/OrderHeader";
import { PeopleList } from "./Components/PeopleList";
import { StepsListPrinter } from "./Components/StepsListPrinter";
import { MoneyListSummary } from "./Components/MoneyListSummary";


export class TableView extends Div
{
    constructor(private _router: Router, private _manager: OrdersManager, orders: CollectionView<Order>)
    {
        super();
        this.TextAlignLeft();

        const profitSum = new RefNumber();
        orders.OnChange(() => profitSum.value = orders.Items.reduce((acc, order) => acc + order.Profit, 0), true);

        this.Append(
            new TableBuilder(orders).MarginTop(16)
                .AddColumn(new Text(orders.FilteredCount, v => v + " łącznie"), 
                    order => new OrderHeader(this._router, this._manager, orders, order))
                .AddColumn("🛒 Zamówienie", order => new BasketList(order))
                .AddColumn("🐾 Kroki", order => new StepsListPrinter(order.Steps))
                .AddColumn("👥 Ludzie", order => new PeopleList(order))
                .AddColumn(new Text(profitSum, v => `💰 Kasa (${v} zł)`), order => new MoneyListSummary(order).Class("tight-table").FontSize(12))
                .ForEachRow((row, order) => this.SetColorRow(row, order))
                .Build()
        );
    }

    private SetColorRow(row: Div, order: Order)
    {
        if (order.Meta.IsNew) row.Background("#ffffdb")
        else if (order.IsDone) row.Background("#e9ffe9")
        else row.Background("");
    }
}
